<template>
  <div id="project-detail-page">
    <loading-component v-if="isLoading"></loading-component>
    <div class="project" v-if="!isLoading">
      <div class="content band-large">
          <div class="container project-overview">
              <div class="project-title d-flex flex-column flex-md-row">
                  <div class="title">
                      <p>{{ currentProject.projectName }}</p>
                  </div>
              </div>
              <div class="project-tags d-flex flex-column flex-md-row">
                  <div class="tags">
                      <ul v-for="tag in currentProject.projectTags" :key="tag.projectId">
                        <li>{{ tag.toUpperCase() }}</li>
                      </ul>
                  </div>
              </div>
              <div class="project-description">
                  <p>{{ currentProject.projectDescription }}</p>
              </div>
          </div>
      </div>
      <main role="main" class="container">
        <div v-for="(media, index) in currentProject.projectMedia" :key="index" class="item">
          <div v-if="media.mediaType == 'image'">
            <img class="feat-item img-fluid" :src="media.mediaFile" />
          </div>
          <div v-if="media.mediaType == 'video'">
            <div class="embed-container">
              <video controls :src="media.mediaFile" v-bind:poster="media.videoPoster" width="1110" onloadstart="this.volume=0.5">
                Sorry, your browser doesn't support embedded videos.
              </video>
            </div>
          </div>
          <div v-if="media.mediaType == 'divider'">
            <img class="feat-item img-fluid" :src="media.mediaFile" />
          </div>
        </div>
        <div class="back-button">
          <router-link class="back-link" :to="{ name: 'HomePage' }">Back To Projects</router-link>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import LoadingComponent from '../components/LoadingComponent'
import axios from 'axios'

export default {
  name: 'ProjectDetailPage',
  components: {
    LoadingComponent
  },
  props: ['id', 'name'],
  data: () => {
    return {
      isLoading: true,
      currentProjectId: null,
      currentProject: null,
      projects: null
    }
  },
  created () {
    this.currentProjectId = parseInt(this.id)
    this.fetchProjectData(this.currentProjectId)

    let self = this
    setTimeout(function () {
      self.isLoading = false
    }, 1000)
  },
  methods: {
    fetchProjectData: function (selectedProject) {
      axios.get('./static/projects.json').then((response) => {
        this.projects = response.data
        let self = this
        this.projects.forEach(function (project) {
          if (project.projectId === selectedProject) {
            self.currentProject = project
            self.currentProject.projectMedia.sort(function (a, b) { return a['mediaSortOrder'] - b['mediaSortOrder'] })
          }
        })
      }, (error) => {
        console.log(error)
      })
    }
  },
  // Update project data on navigate
  beforeRouteUpdate (to, from, next) {
    this.selectCurrentProject()
    next()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/ProjectDetailPage.vue